const IMAGE_MISS_MARKERS = [
  'no image was included',
  'no image included',
  'attached image not received',
  'image was not included',
  'image was not attached',
  'no image was attached',
  'screenshot was not included',
  'could not view the attached',
  'no image was received',
];

/** True when the planner returned a placeholder instead of reading the screenshot. */
export function tripDraftAdmitsMissingImage(draft: unknown): boolean {
  const text = JSON.stringify(draft || {}).toLowerCase();
  return IMAGE_MISS_MARKERS.some(marker => text.includes(marker));
}
